import { dashboardSelector, setFormAction } from "@/store/features/dashboardSlice";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

export const useFormChangeWarning = (isDirty: boolean, disableWarning = false): void => {
  const { action } = useSelector(dashboardSelector);
  const dispatch = useDispatch();

  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent): string | undefined => {
      if (isDirty && !disableWarning) {
        e.preventDefault();
        const message = "You have unsaved changes. Are you sure you want to leave?";
        e.returnValue = message;
        return message;
      }
    };

    if (isDirty && !disableWarning && action !== "FORM_FILL") {
      dispatch(setFormAction("FORM_FILL"));
      window.addEventListener("beforeunload", handleBeforeUnload);
    } else {
      dispatch(setFormAction(""));
    }

    return () => {
      dispatch(setFormAction(""));
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [isDirty, disableWarning, dispatch]);
};
